import { render, staticRenderFns } from "./colored.vue?vue&type=template&id=5cbbc32c&lang=true&"
import script from "./colored.vue?vue&type=script&lang=js&"
export * from "./colored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports